import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'

interface LoaderProps {
    loader: boolean
}

const Loader = (props: LoaderProps) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={props.loader}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default Loader
